import michelinLogo from '../../../images/logos/bib.jpg';

export const MichelinLogo = {
  LIGHT: michelinLogo,
  DARK: michelinLogo,
  DEFAULT: michelinLogo,
};
